module.exports = __webpack_public_path__ + "zw.8fc574af823754b44c4d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/zw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/zw.svg
// module chunks = styles